import { isDefined } from '@hsp/utilities';

import { IResult } from 'types/api/common/operation-results/success-result.model';

export const defaultResult = <T>(data?: T): IResult<T> => ({
  dataContainer: isDefined(data) ? data : null,
  failure: false,
  success: true,
});
